import React, { useRef } from 'react';
import WhatsAppCTA from './WhatsAppCTA';
import { CTA_LABEL, IMAGES, REGION, quoteMessage } from '../data/site';
import { gsap, useGSAP, MOTION_OK } from '../lib/gsap';

const Hero = () => {
  const scope = useRef(null);

  // Entrada em ordem de leitura: título, texto, botão. As fotos abrem por último
  // para o olho chegar nelas depois de entender a oferta.
  useGSAP(
    () => {
      // No desktop cada linha sobe de dentro de uma máscara; no celular o título
      // quebra livre, então entra inteiro com fade.
      gsap.matchMedia().add({ motion: MOTION_OK, desktop: '(min-width: 640px)' }, ({ conditions }) => {
        if (!conditions.motion) return;
        gsap
          .timeline()
          .from(conditions.desktop ? '[data-hero-line]' : 'h1', conditions.desktop ? { yPercent: 110, duration: 0.9, stagger: 0.08, ease: 'power4.out' } : { autoAlpha: 0, y: 20 })
          .from('[data-hero-fade]', { autoAlpha: 0, y: 16, stagger: 0.08 }, '-=0.5')
          .from('[data-hero-photo]', { clipPath: 'inset(100% 0% 0% 0%)', duration: 1.1, stagger: 0.15, ease: 'expo.out' }, '-=0.7')
          .from('[data-hero-photo] img', { scale: 1.15, duration: 1.4, stagger: 0.15, ease: 'expo.out' }, '<');
      });
    },
    { scope }
  );

  const goTo = (e) => {
    e.preventDefault();
    document.querySelector('#eventos')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="topo" ref={scope} data-testid="hero-section" className="px-4 pb-20 pt-24 md:px-8 md:pb-24 md:pt-24">
      <div className="mx-auto grid max-w-7xl items-center gap-12 lg:grid-cols-12 lg:gap-8">
        <div className="lg:col-span-7">
          <h1
            className="font-display text-[2.75rem] font-bold leading-[1.02] tracking-[-0.03em] sm:text-6xl lg:text-[3.5rem] xl:text-[4rem]"
            data-testid="hero-title"
          >
            <span className="sm:block sm:overflow-hidden sm:pb-1">
              <span data-hero-line className="sm:block">
                Som, luz e pista cheia{' '}
              </span>
            </span>
            <span className="sm:block sm:overflow-hidden sm:pb-1">
              <span data-hero-line className="sm:block">
                para o seu evento.
              </span>
            </span>
          </h1>

          <p data-hero-fade className="mt-6 max-w-[46ch] text-lg leading-relaxed text-soft" data-testid="hero-subtitle">
            Há mais de 15 anos o DJ Paulo anima casamentos, aniversários e eventos corporativos em {REGION}.
          </p>

          <div data-hero-fade className="mt-9 flex flex-col gap-3 sm:flex-row sm:items-center">
            <WhatsAppCTA message={quoteMessage()} source="hero" testid="hero-cta-button">
              {CTA_LABEL}
            </WhatsAppCTA>
            <a
              href="#eventos"
              onClick={goTo}
              className="inline-flex items-center justify-center rounded-full border border-line px-7 py-4 text-base font-semibold transition-colors hover:border-ink/40 active:scale-[0.98]"
              data-testid="hero-events-link"
            >
              Ver eventos
            </a>
          </div>
        </div>

        <div className="relative pb-8 lg:col-span-5">
          <figure data-hero-photo className="ml-auto w-[82%] overflow-hidden rounded-2xl sm:w-[70%] lg:w-[85%]">
            <img src={IMAGES.paulo.src} alt={IMAGES.paulo.alt} fetchPriority="high" width="753" height="774" className="aspect-[4/5] w-full object-cover" />
          </figure>
          <figure
            data-hero-photo
            className="absolute bottom-0 left-0 w-[46%] overflow-hidden rounded-2xl border-4 border-page sm:w-[40%] lg:-left-6 lg:w-[48%]"
          >
            <img src={IMAGES.crowd.src} alt={IMAGES.crowd.alt} width="795" height="819" className="aspect-square w-full object-cover" />
          </figure>
        </div>
      </div>
    </section>
  );
};

export default Hero;
